export default {
	props: {
		disabled: {
			type: Boolean,
		},
	},
	methods: {
		trataAcaoDeBotaoDesabilitado(funcao, isDisabled = null) {
			if (isDisabled === null) isDisabled = this.disabled

			if (!isDisabled) {
				funcao()
			}
		},
	},
}
